import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	project: {
		id: 'relay.jira-dc.project-result.label',
		defaultMessage: 'Project',
		description: 'Project label',
	},
	space: {
		id: 'relay.jira-dc.space-result.label',
		defaultMessage: 'Space',
		description: 'Space label',
	},
	issue: {
		id: 'relay.jira-dc.issue-result.label',
		defaultMessage: 'Work item',
		description: 'Issue label',
	},
	commment: {
		id: 'relay.jira-dc.comment-result.label',
		defaultMessage: 'Comment',
		description: 'Comment label',
	},
});
